"use client";

import styles from "@/styles/contact/index.module.scss";
import ContactForm from "@/app/components/contact/ContactForm";
import Link from "next/link";
import { useAppSelector } from "@/store/hooks";

export default function ContactPage() {
  // 从Redux store获取用户状态
  const { hasLogin } = useAppSelector((state) => state.user);

  return (
    <div className={styles["page-contact"]}>
      <div className={styles["page-title"]}>Contact Us</div>

      <div className={styles["contact-phone"]}>
        <span className={styles["phone-number"]}>03 9111 5708</span>  |  Mon-Fri 8AM-5PM AEST
      </div>

      <div className={styles["contact-description"]}>
        If you would like a Customer Service Representative to contact you, please complete the below form.
      </div>

      {!hasLogin ? (
        <div className={styles["login-tips"]}>
          Please login !{" "}
          <Link href={"/login"}>
            <span className={styles["login-link"]}>click here</span>
          </Link>
        </div>
      ) : null}


      <ContactForm />
    </div>
  );
}

